import {
  Request,
  RequestItinerary,
  RequestStandardAssignments,
  RequestTicketStatusSync,
  RequestTicket,
  ResponseDataError,
  ResponseDataPaginate
} from 'src/types'

export enum RequestsActionTypes {
  GET_FULL_REQUEST = '@requests/GET_FULL_REQUEST',
  GET_FULL_REQUEST_FAILURE = '@requests/GET_FULL_REQUEST_FAILURE',
  GET_FULL_REQUEST_SUCCESS = '@requests/GET_FULL_REQUEST_SUCCESS',
  GET_MY_REQUESTS = '@requests/GET_MY_REQUESTS',
  GET_MY_REQUESTS_FAILURE = '@requests/GET_MY_REQUESTS_FAILURE',
  GET_MY_REQUESTS_SUCCESS = '@requests/GET_MY_REQUESTS_SUCCESS',
  RESET_SAVE_FULL_REQUEST = '@requests/RESET_SAVE_FULL_REQUEST',
  SAVE_FULL_REQUEST = '@requests/SAVE_FULL_REQUEST',
  SAVE_FULL_REQUEST_FAILURE = '@requests/SAVE_FULL_REQUEST_FAILURE',
  SAVE_FULL_REQUEST_SUCCESS = '@requests/SAVE_FULL_REQUEST_SUCCESS',
  SAVE_REQUEST_ITINERARY = '@requests/SAVE_REQUEST_ITINERARY',
  SAVE_REQUEST_ITINERARY_FAILURE = '@requests/SAVE_REQUEST_ITINERARY_FAILURE',
  SAVE_REQUEST_ITINERARY_SUCCESS = '@requests/SAVE_REQUEST_ITINERARY_SUCCESS',
  SAVE_REQUEST_STANDARD_ASSIGNMENTS = '@requests/SAVE_REQUEST_STANDARD_ASSIGNMENTS',
  SAVE_REQUEST_STANDARD_ASSIGNMENTS_FAILURE = '@requests/SAVE_REQUEST_STANDARD_ASSIGNMENTS_FAILURE',
  SAVE_REQUEST_STANDARD_ASSIGNMENTS_SUCCESS = '@requests/SAVE_REQUEST_STANDARD_ASSIGNMENTS_SUCCESS',
  SAVE_REQUEST_TICKETS = '@requests/SAVE_REQUEST_TICKETS',
  SAVE_REQUEST_TICKETS_FAILURE = '@requests/SAVE_REQUEST_TICKETS_FAILURE',
  SAVE_REQUEST_TICKETS_SUCCESS = '@requests/SAVE_REQUEST_TICKETS_SUCCESS',
  SET_DRAFT = '@requests/SET_DRAFT',
  SET_FULL_REQUEST = '@requests/SET_FULL_REQUEST',
  SET_RECEIPT_CONFERENCE_CHECK = '@requests/SET_RECEIPT_CONFERENCE_CHECK',
  SET_REQUEST_TOTALS = '@requests/SET_REQUEST_TOTALS',
  SET_UNDERWAY_STATUS = '@requests/SET_UNDERWAY_STATUS',
  SET_UNDERWAY_STATUS_FAILURE = '@requests/SET_UNDERWAY_STATUS_FAILURE',
  SET_UNDERWAY_STATUS_SUCCESS = '@requests/SET_UNDERWAY_STATUS_SUCCESS'
}

export type OriginRequest =
  | 'approvals'
  | 'audits'
  | 'closings'
  | 'conferences'
  | 'issuances'
  | 'my_requests'

export interface ResponseDataRequestTotals {
  request_totals: {
    total_approvals: number
    total_audits: number
    total_closings: number
    total_conferences: number
    total_mocks: number
    total_requests: number
    total_toodopay: number
  }
}

export type ResponseDataRequestsItem = Pick<
  Request,
  | 'cost'
  | 'empowered_users'
  | 'erp_code'
  | 'organization_id'
  | 'request_id'
  | 'request_number'
  | 'request_user_data'
  | 'requested_on'
  | 'requester'
  | 'status'
  | 'ticket_types'
  | 'title'
> & {
  sync_status: RequestTicketStatusSync
}

export type ResponseDataRequestItineraries = {
  request_itineraries: RequestItinerary[]
}

export type ResponseDataRequestStandardAssignments = {
  request_standard_assignments: RequestStandardAssignments
}

export type ResponseDataFullRequest = {
  full_request: Request
}

export type ResponseDataTickets = ResponseDataError & {
  request_tickets: RequestTicket[]
}

export type ResponseDataRequests = ResponseDataPaginate &
  ResponseDataRequestTotals & {
    requests: ResponseDataRequestsItem[]
  }

export interface RequestsState extends ResponseDataRequestTotals {
  readonly draft: Request
  readonly filterRequestNumber: string
  readonly filterStatus: string[]
  readonly fullRequest: Request
  readonly fullRequestError: string
  readonly fullRequestLoading: boolean
  readonly fullRequestReloading: boolean
  readonly myRequests: ResponseDataRequestsItem[]
  readonly myRequestsError: string
  readonly myRequestsLoading: boolean
  readonly myRequestsReloading: boolean
  readonly saveFullRequestError: string
  readonly saveFullRequestLoading: boolean
  readonly saveFullRequestSuccess: string
  readonly setStatusError: string
  readonly setStatusLoading: boolean
  readonly totalResults: number
}
